var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowdropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ic_navforward",
    fill: "#F2BF30",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52053571,3.57225 L8.46964286,6.6 L1.28571429,6.6 C0.574955357,6.6 0,7.189875 0,7.92 C0,8.650125 0.574955357,9.24 1.28571429,9.24 L8.46964286,9.24 L5.52133929,12.266925 C5.26741071,12.5235 5.14285714,12.86175 5.14285714,13.2 C5.14285714,13.53825 5.26841518,13.875675 5.51953125,14.133075 C6.02176339,14.6487 6.83537946,14.6487 7.33761161,14.133075 L12.4804687,8.853075 C12.9827009,8.33745 12.9827009,7.5021375 12.4804687,6.9865125 L7.33761161,1.7065125 C6.83537946,1.1908875 6.02176339,1.1908875 5.51953125,1.7065125 C5.01729911,2.2221375 5.01830357,3.056625 5.52053571,3.57225 Z M15.4285714,1.32 L15.4285714,14.52 C15.4285714,15.2497125 16.0035268,15.84 16.7142857,15.84 C17.4250446,15.84 18,15.2497125 18,14.52 L18,1.32 C18,0.5902875 17.4250446,0 16.7142857,0 C16.0035268,0 15.4285714,0.5902875 15.4285714,1.32 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdropdown);
export default __webpack_public_path__ + "static/media/arrowdropdown.482c987be279db415f1f59eebde505a5.svg";
export { ForwardRef as ReactComponent };